// extracted by mini-css-extract-plugin
export default {"form-wrapper":"CreateCustomer_form-wrapper__7z6GI","form-group":"CreateCustomer_form-group__hDLft"};